import FauxButton from './FauxButton';

export default FauxButton;
